export default __webpack_public_path__ + "ef9b796c729dc3b8399713b25836d66a.png";